import { type Module } from "~/foundation/Bootstrapper/types";
import { onClickOutside, removeOnClickOutside } from "~/foundation/Events/onClickOutside";
import { triggerCustomEvent } from "~/foundation/Events/triggerCustomEvent";

export const SectionSubNavigation: Module = (container: HTMLElement) => {
	const linkButton = container.querySelector("[data-link-button]");
	const linkList = container.querySelector("[data-link-list]");
	const isNavMoreTop = container.classList.contains("nav__more") && container.closest(".top-navigation");

	if (!linkButton || !linkList) return;

	const toggle = () => {
		linkButton.ariaExpanded === "false" ? open() : close();
	}

	const open = () => {
		linkButton.ariaExpanded = "true";
		linkList.classList.add("open");
		if (isNavMoreTop){
			// Trigger custom event to pause top story slider autoplay
			triggerCustomEvent(document.body, "pauseTopStorySlider", {});
		}
		onClickOutside(container, close, window, true);
	}

	const close = () => {
		linkButton.ariaExpanded = "false";
		linkList.classList.remove("open");
		if (isNavMoreTop){
			// Trigger custom event to pause top story slider autoplay
			triggerCustomEvent(document.body, "resumeTopStorySlider", {});
		}
		removeOnClickOutside(container, close, window);
	}

	linkButton.addEventListener("click", toggle);
}

export default SectionSubNavigation;